module.exports = __webpack_public_path__ + "static/media/W7.944f6fcf.jpg";